import { BaseDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/BaseDrawOption';

export class AccountManagerDrawOption extends BaseDrawOption {}
